module.exports = __webpack_public_path__ + "img/consultoria_4-3_3072.27a11b75.webp";